import { NgModule } from "@angular/core";
import { Routes, RouterModule, CanActivate } from "@angular/router";

import { HomeComponent } from "./home/home.component";
import { LoginComponent } from "./login/login.component";
import { NewParkingPlaceComponent } from "./new-parking-place/new-parking-place.component";
import { ViewParkingPlaceComponent } from "./view-parking-place/view-parking-place.component";
import { ViewUserComponent } from "./view-user/view-user.component";

import { HeaderComponent } from "../core/header/header.component";
import { FooterComponent } from "../core/footer/footer.component";
import { NavComponent } from "../core/nav/nav.component";

import {
  OnlyLoggedInUsersGuard,
  OnlyAdminGuard,
} from "../services/guards.service";
import { DashboardComponent } from "./dashboard/dashboard.component";
import { NewValletParkingComponent } from "./new-vallet-parking/new-vallet-parking.component";
import { ViewValletParkingComponent } from "./view-vallet-parking/view-vallet-parking.component";
import { ParkingPlaceParkingStaffsComponent } from "../components/parking-place-parking-staffs/parking-place-parking-staffs.component";
import { ValletParkingStaffsComponent } from "./vallet-parking-staffs/vallet-parking-staffs.component";

export const bodyRoutes: Routes = [
  { path: "user", redirectTo: "user/home" },
  {
    path: "user",
    canActivate: [OnlyLoggedInUsersGuard],
    children: [
      { path: "home", component: HomeComponent },
      { path: "dashboard", component: DashboardComponent },

      {
        path: "coupons",
        loadChildren: () =>
          import("./coupons/coupons.routes").then((m) => m.COUPONS_ROUTES),
      },
      {
        path: "reports/pass_tickets",
        loadChildren: () =>
          import("./valet-tickets-history-report/tickets-report-routes").then(
            (m) => m.VALET_TICKETS_HISTORY_REPORT_ROUTES,
          ),
      },
      {
        path: "reports/valet_shop_details",
        loadChildren: () =>
          import("./valet-shop-details-report/shop-details-report-routes").then(
            (m) => m.VALET_SHOP_DETAILS_REPORT_ROUTES,
          ),
      },
      {
        path: "reports/valet_validation",
        loadChildren: () =>
          import("./valet-validation-report/validation-report-routes").then(
            (m) => m.VALET_VALIDATION_REPORT_ROUTES,
          ),
      },
      {
        path: "reports/guest_tickets",
        loadChildren: () =>
          import("./valet-guest-transaction-report/valet-guest-transaction-report-routes").then(
            (m) => m.VALET_GUEST_TICKET_REPORT_ROUTES,
          ),
      },
      {
        path: "reports/valet_booth_transaction",
        loadChildren: () =>
          import("./valet-booth-transaction-report/valet-booth-transaction-report.routes").then(
            (m) => m.VALET_BOOTH_TRANSACTION_REPORT_ROUTES,
          ),
      },
      {
        path: "settings/valet_car_brand",
        loadChildren: () =>
          import("./unregistered-tickets/unregistered-tickets.routes").then(
            (m) => m.UNREGISTERED_TICKETS_ROUTES,
          ),
      },
      {
        path: "settings/valet_system_messages",
        loadChildren: () =>
          import("./system-message/system-message.routes").then(
            (m) => m.SYSTEM_MESSAGE_ROUTES,
          ),
      },
      {
        path: "reports/without_charge",
        loadChildren: () =>
          import("./valet-staff-card-report/without-charge-routes").then(
            (m) => m.VALET_STAFF_CARD_REPORT_ROUTES,
          ),
      },

      {
        path: "reports/valet_staff_list",
        loadChildren: () =>
          import("./valet-staff-list-report/qrcode-tickets-report-routes").then(
            (m) => m.VALET_STAFF_LIST_REPORT_ROUTES,
          ),
      },
      {
        path: "reports/car_parked_per_location",
        loadChildren: () =>
          import("./car-parked-per-location-report/car-parked-location-routes").then(
            (m) => m.CAR_PARKED_PER_LOCATION_ROUTES,
          ),
      },
      {
        path: "reports/valet_ticket_revenue",
        loadChildren: () =>
          import("./valet-ticket-revenue-report/valet-ticket-revenue-routes").then(
            (m) => m.VALET_TICKET_REVENUE_REPORT_ROUTES,
          ),
      },
      {
        path: "reports/avg_car_parked_time",
        loadChildren: () =>
          import("./avg-car-parked-time-report/avg-car-parked-time-report.routes").then(
            (m) => m.AVG_CAR_PARKED_TIME_REPORT_ROUTES,
          ),
      },
      {
        path: "reports/peak_hour_analysis",
        loadChildren: () =>
          import("./peak-hour-analysis-report/peak-hour-analysis-routes").then(
            (m) => m.PEAK_HOUR_ANALYSIS_ROUTES,
          ),
      },
      {
        path: "reports/avg_car_retrieval_time",
        loadChildren: () =>
          import("./avg-car-retrieval-time-report/avg-car-retrieval-time.routes").then(
            (m) => m.AVG_CAR_RETRIEVAL_TIME_ROUTES,
          ),
      },
      {
        path: "valletparking",
        loadChildren: () =>
          import("./vallet-parking/vallet-parking-routes").then(
            (m) => m.VALLET_PARKING_ROUTES,
          ),
      },

      {
        path: "valletparking/add",
        component: NewValletParkingComponent,
      },
      { path: "valletparking/:id", component: ViewValletParkingComponent },
      {
        path: "",
        canActivate: [OnlyAdminGuard],
        children: [
          {
            path: "settlements/add",
            loadChildren: () =>
              import("./create-settlement/create-settlement-routes").then(
                (m) => m.CREATE_SETTLEMENT_ROUTES,
              ),
          },
          {
            path: "channel-collection-settlements/add-collection",
            loadChildren: () =>
              import("./create-channel-collection-settlement/create-channel-collcetion-settlement-routes").then(
                (m) => m.CREATE_CHANNEL_COLLECTION_SETTLEMENT_ROUTES,
              ),
          },
          {
            path: "channel-tickets-settlements/add-channel",
            loadChildren: () =>
              import("./create-channel-partner-settlement/create-channel-partner-settlement-routes").then(
                (m) => m.CREATE_CHANNEL_PARTNER_SETTLEMENT_ROUTES,
              ),
          },
          {
            path: "parkingplaces/add",
            component: NewParkingPlaceComponent,
          },
          {
            path: "parkingplaces/create-parking-staff",
            component: ParkingPlaceParkingStaffsComponent,
          },
          {
            path: "valletparking/create-vallet-staff",
            component: ValletParkingStaffsComponent,
          },
        ],
      },
    ],
  },
];
